import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import stl from "./AppointmentScheduled.module.css";
import { useLang } from "@/common/Contexts/LanguageContext";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";
import NeedHelp from "@/_MiniApps/NeedHelp/NeedHelp";
import { createTimestampAndNextNDays } from "@/utils/GlobalJavascriptFunction";
var AppointmentScheduled = function AppointmentScheduled(_ref) {
  var _location;
  var t = _ref.t,
    pageData = _ref.pageData,
    requestId = _ref.requestId,
    navigate = _ref.navigate;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var queryParams = __IS_CSR__ ? new URLSearchParams((_location = location) === null || _location === void 0 ? void 0 : _location.search) : undefined;
  var infoFormStep = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("formStep");
  var isUserLocation = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("isUserLocation");
  var amount_Fee = queryParams === null || queryParams === void 0 ? void 0 : queryParams.get("amount_Fee");
  var _useState = useState(null),
    myTimestamp = _useState[0],
    setMyTimestamp = _useState[1];
  var _useState2 = useState(infoFormStep === "sell_car_appointment_book"),
    isFromSellTrade = _useState2[0];
  var lang = useLang();
  var webview = useWebView();
  var isWebView = useIsWebView();
  useEffect(function () {
    setMyTimestamp(createTimestampAndNextNDays(pageData === null || pageData === void 0 ? void 0 : pageData.timestamp));
  }, [pageData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.appointmentIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("appointment_booked_successfully", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("p", null, !isUserLocation ? t("appointment_rescheduled_new_date", {
    ns: "web_Schedule"
  }) : isUserLocation && isUserLocation === "1" ? t("contact_soon_provide_location_map", {
    ns: "web_Schedule"
  }) : t("appointment_details_sent_via_whatsapp", {
    ns: "web_Schedule"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.innerContainer
  }, /*#__PURE__*/React.createElement("strong", null, pageData === null || pageData === void 0 ? void 0 : pageData.title), myTimestamp && /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.calenderIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("date", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.dayName(lang), " ", (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.day()) + "/" + (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.month()) + "/" + (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.year())))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.clockIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("time", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.timeForView(lang))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.locationIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("location", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) === "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) === "" && (pageData === null || pageData === void 0 ? void 0 : pageData.location)), /*#__PURE__*/React.createElement("span", null, lang === "ar" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) !== "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar)), /*#__PURE__*/React.createElement("span", null, lang === "en" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) !== "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en))))), /*#__PURE__*/React.createElement("button", {
    className: ["blueBtn", stl.btn].join(" "),
    onClick: function onClick() {
      webview.closeScreen()["catch"](function () {
        if (isWebView) return document.location.href = "app://close";
        document.location.href = createUrl("/");
      });
    }
  }, t("go_homepage", {
    ns: "web_Schedule"
  })), !isFromSellTrade && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      navigate(createUrl("/schedule/".concat(requestId), {
        schedulestep: "reschedule"
      }));
    },
    className: [stl.btn, "whtBtn"].join(" ")
  }, t("reschedule_appointment", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement(NeedHelp, {
    className: [stl.helpContainer].join(" ")
  }));
};
export default AppointmentScheduled;